import BecomeAProvider from "./BecomeAProvider"

export default BecomeAProvider
